// Rúbricas oficiales del Portafolio Docente 2026 — Módulo 2 (Clase Grabada)
// Fuente: PDFs oficiales CPEIP/MINEDUC (Generalista, 1°-6° Básico, 7°B-4°M Asignaturas)
// Los textos de los 4 niveles son los oficiales. La lectura por perfil docente
// (Generalista / Básica / Media) se inyecta dinámicamente en el chat IA del backend.
// Los resultados nacionales provienen de la fuente única: resultados-nacionales.js

import { RESULTADOS_NACIONALES } from './resultados-nacionales';

function withResultados(rubrica) {
    const data = RESULTADOS_NACIONALES[rubrica.indicadorId];
    if (data) {
        rubrica.resultadosNacionales = {
            destacado: data.destacado,
            competente: data.competente,
            basico: data.basico,
            insatisfactorio: data.insatisfactorio,
            totalDocentes: data.totalDocentes,
            lecturaSistema: data.lecturaSistema,
            dificultad: data.dificultad,
            implicancia: data.implicancia,
        };
    }
    return rubrica;
}

export const RUBRICAS_OFICIALES_M2 = [
    {
        id: 'rubrica-m2-9',
        tarea: 'tarea-4',
        tareaLabel: 'Tarea 4',
        indicadorId: 'indicador-m2-9',
        indicadorNum: 9,
        nombre: 'Ambiente para el aprendizaje',
        descripcion: 'Evalúa la capacidad del/la docente para promover un ambiente que propicia el aprendizaje, generando relaciones de confianza, valoración, respeto y equidad con sus estudiantes.',
        evidencia: 'Tarea 4. Grabación de la clase.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: ['No cumple con la condición del nivel Básico.'],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'Durante la MAYOR PARTE de la clase se evidencia un ambiente de aula que propicia el aprendizaje en el que se observa una buena convivencia.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'Durante TODA la clase se evidencia un ambiente de aula que propicia el aprendizaje en el que se observa una buena convivencia.',
                    'Se observa una relación de confianza entre docente y estudiantes.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple con el nivel Competente y, además:',
                    'El/la docente propone una actividad en la que son los/as estudiantes quienes construyen o descubren los aprendizajes de la clase.',
                ],
            },
        },
        notas: [
            'Buena convivencia: trato respetuoso, escucha mutua, sin discriminación. Estudiantes focalizados/as. El/la docente reestablece la convivencia cuando se interrumpe.',
            'Relación de confianza: interacción horizontal y cómoda. El/la docente se detiene ante intervenciones de estudiantes (correctas o incorrectas) y las valora. Los/as estudiantes participan espontáneamente, aportan, discrepan, plantean inquietudes.',
        ],
    },
    {
        id: 'rubrica-m2-10',
        tarea: 'tarea-4',
        tareaLabel: 'Tarea 4',
        indicadorId: 'indicador-m2-10',
        indicadorNum: 10,
        nombre: 'Promoción de la participación y colaboración',
        descripcion: 'Evalúa la capacidad del/la docente para promover que los/as estudiantes participen y COLABOREN con el aprendizaje de sus compañeros/as.',
        evidencia: 'Tarea 4. Grabación de la clase.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: [
                    'No cumple con la condición del nivel Básico.',
                    'O es evidente que el/la docente ofrece participación solo a algunos/as estudiantes.',
                ],
            },
            basico: {
                label: 'Básico',
                criterios: ['El/la docente logra que sus estudiantes participen a lo largo de la clase.'],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'El/la docente logra que sus estudiantes participen a lo largo de la clase.',
                    'Y que colaboren con el aprendizaje de sus pares (se guían, modelan procedimientos, explican conceptos, evalúan respuestas, trabajan en conjunto).',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple Competente y además:',
                    'Se observa SISTEMÁTICAMENTE que los/as estudiantes colaboran con el aprendizaje de sus pares.',
                ],
            },
        },
        notas: [
            'Colaborar con el aprendizaje de pares = interactuar entre ellos/as en función del aprendizaje (no es solo trabajo grupal: implica interdependencia y enseñanza mutua).',
        ],
    },
    {
        id: 'rubrica-m2-11',
        tarea: 'tarea-5',
        tareaLabel: 'Tarea 5',
        indicadorId: 'indicador-m2-11',
        indicadorNum: 11,
        nombre: 'Contribución de las actividades al logro de los objetivos',
        descripcion: 'Evalúa la capacidad del/la docente para organizar las actividades de manera que contribuyan al logro de los objetivos, aprovechando el tiempo en función de los aprendizajes.',
        evidencia: 'Tarea 5. Grabación de la clase + Ficha de la Clase Grabada (objetivos declarados).',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: [
                    'No cumple con la condición del nivel Básico.',
                    'ADVERTENCIA: cualquier error conceptual en lo que se enseña baja este indicador al nivel mínimo.',
                ],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'Coherencia entre la MAYORÍA de los objetivos y las actividades (abordaje parcial de habilidades/conceptos/procedimientos).',
                    'El tiempo NO es adecuado para algunas actividades grupales o individuales.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'Coherencia entre TODOS los objetivos y TODAS las actividades.',
                    'El tiempo es adecuado: no sobra ni falta tiempo para ninguna actividad.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple Competente y además:',
                    'Propone objetivos relacionados con aprendizajes actitudinales o transversales.',
                    'Monitorea EXPLÍCITAMENTE el avance o desarrollo de estos aprendizajes durante la clase.',
                ],
            },
        },
        notas: [
            'Error conceptual ⇒ nivel más bajo automáticamente. Cuida las definiciones y procedimientos que enseñas.',
            'El monitoreo del aprendizaje actitudinal/transversal debe ser EXPLÍCITO y visible en la grabación.',
        ],
    },
    {
        id: 'rubrica-m2-12',
        tarea: 'tarea-5',
        tareaLabel: 'Tarea 5',
        indicadorId: 'indicador-m2-12',
        indicadorNum: 12,
        nombre: 'Promoción de habilidades para aprendizaje profundo',
        descripcion: 'Evalúa la capacidad del/la docente para implementar actividades que contribuyan al desarrollo de pensamiento crítico, creativo o metacognición.',
        evidencia: 'Tarea 5. Grabación de la clase.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: ['No cumple con la condición del nivel Básico.'],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'Promueve que justifiquen respuestas pero SIN orientarlos a basarse en análisis de información.',
                    'O promueve que creen una solución/producto.',
                    'O promueve que identifiquen lo que aprenden y lo que no.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'Promueve que ARGUMENTEN sus respuestas en base al análisis de información.',
                    'Promueve que EXPLOREN diversas ideas antes de crear una solución/producto.',
                    'Promueve que DESCRIBAN procesos o estrategias de aprendizaje (metacognición).',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple Competente y además promueve que los/as estudiantes EVALÚEN o CUESTIONEN:',
                    'La información analizada (pensamiento crítico).',
                    'Las ideas exploradas para una solución (pensamiento creativo).',
                    'Los procesos/estrategias de aprendizaje (metacognición).',
                ],
            },
        },
        notas: [
            'El aprendizaje profundo es un PROCESO: no se exige logro de los estudiantes en la clase grabada, pero sí la PROMOCIÓN activa.',
            'Las actividades deben proponerse al CURSO COMPLETO, no a algunos/as.',
        ],
    },
    {
        id: 'rubrica-m2-13',
        tarea: 'tarea-6',
        tareaLabel: 'Tarea 6',
        indicadorId: 'indicador-m2-13',
        indicadorNum: 13,
        nombre: 'Uso de conocimientos y experiencias de estudiantes',
        descripcion: 'Evalúa la capacidad del/la docente para incorporar las experiencias y conocimientos de los/as estudiantes con el fin de enriquecer la comprensión de los aprendizajes.',
        evidencia: 'Tarea 6. Grabación de la clase.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: ['No cumple con alguna de las condiciones del nivel Básico.'],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'Promueve que den cuenta de conocimientos/experiencias pero NO los integra a los aprendizajes.',
                    'O propone aplicación en un contexto que NO considera sus características.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'Promueve que den cuenta de conocimientos/experiencias e INTEGRA esos conocimientos a los aprendizajes abordados.',
                    'O propone aplicación en un contexto que SÍ considera sus características, conocimientos o experiencias.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple Competente y además:',
                    'Se observa que en DISTINTAS OCASIONES durante la clase implementa estas estrategias de integración.',
                ],
            },
        },
        notas: [
            'INTEGRAR ≠ recoger. Integrar implica conectar, ampliar y construir relaciones entre lo que emerge desde los/as estudiantes y los aprendizajes abordados.',
            'El contexto de aplicación debe vincularse con intereses, edad, contexto familiar/social/cultural REAL del curso.',
        ],
    },
    {
        id: 'rubrica-m2-14',
        tarea: 'tarea-6',
        tareaLabel: 'Tarea 6',
        indicadorId: 'indicador-m2-14',
        indicadorNum: 14,
        nombre: 'Retroalimentación: uso de desempeños para el aprendizaje',
        descripcion: 'Evalúa la capacidad del/la docente para estar alerta a los desempeños de los/as estudiantes y aprovecharlos (aciertos y errores) para orientar el aprendizaje.',
        evidencia: 'Tarea 6. Grabación de la clase.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: ['No cumple con la condición del nivel Básico.'],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'Aborda las intervenciones de sus estudiantes agregando información a sus respuestas o corrigiendo cuando son incorrectos.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'EN ALGUNAS OCASIONES aprovecha las intervenciones para promover que los/as estudiantes ANALICEN sus propios desempeños (correctos).',
                    'U orienta para que alcancen el desempeño esperado (incorrectos/incompletos).',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'SISTEMÁTICAMENTE aprovecha las intervenciones para promover análisis de desempeños propios u orientar al desempeño esperado.',
                ],
            },
        },
        notas: [
            'El salto Básico→Competente está en pasar de CORREGIR a hacer que el/la estudiante ANALICE su propio desempeño.',
            'Destacado exige SISTEMATICIDAD: la retroalimentación formativa debe ser un patrón de la clase, no un evento aislado.',
        ],
    },
    {
        id: 'rubrica-m2-15',
        tarea: 'tarea-6',
        tareaLabel: 'Tarea 6',
        indicadorId: 'indicador-m2-15',
        indicadorNum: 15,
        nombre: 'Equidad de género',
        descripcion: 'Evalúa la capacidad del/la docente para contribuir a desnaturalizar y evitar la reproducción de sesgos y estereotipos de género, a partir de un diseño pedagógico y/o gestión de las interacciones que considera el enfoque de género.',
        evidencia: 'Tarea 4. Grabación de la clase + Ficha de la Clase Grabada (apartado "Describa qué hizo en la clase para contribuir a desnaturalizar y evitar la reproducción de sesgos o estereotipos de género").',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: [
                    'No cumple con lo señalado en el nivel Básico.',
                    'O reproduce estereotipos/sesgos de género en el diseño pedagógico o las interacciones.',
                ],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'Diseño pedagógico que NO reproduce sesgos o estereotipos de género.',
                    'Promueve intencionadamente igualdad de oportunidades para la participación de mujeres y hombres.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'Diseño pedagógico que DESNATURALIZA sesgos/estereotipos de género.',
                    'Promueve intencionadamente que mujeres y hombres asuman roles que los desnaturalizan en las interacciones.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple Competente y además:',
                    'Promueve que las/los ESTUDIANTES cuestionen los sesgos/estereotipos a partir de las actividades o interacciones de la clase.',
                ],
            },
        },
        notas: [
            'DESNATURALIZAR ≠ tratar igual. Desnaturalizar implica entender que los estereotipos son construcciones sociales y culturales modificables, no naturales.',
            'El salto a Destacado está en que los/as ESTUDIANTES cuestionen, no solo el/la docente.',
            'Debe declararse en la Ficha de la Clase qué se hizo para desnaturalizar.',
        ],
    },
].map(withResultados);

export const RUBRICAS_M2_POR_TAREA = {
    'tarea-4': RUBRICAS_OFICIALES_M2.filter((r) => r.tarea === 'tarea-4'),
    'tarea-5': RUBRICAS_OFICIALES_M2.filter((r) => r.tarea === 'tarea-5'),
    'tarea-6': RUBRICAS_OFICIALES_M2.filter((r) => r.tarea === 'tarea-6'),
};
